<template>
  <div style="padding: 32px">
    <el-form :inline="true" :model="formData" class="">
      <el-form-item label="日志类型">
        <el-select v-model="formData.type">
          <el-option label="info" value="info" />
          <el-option label="error" value="error" />
        </el-select>
      </el-form-item>

      <el-form-item label="日期">
        <el-date-picker v-model="formData.date" />
      </el-form-item>

      <el-form-item label="行数">
        <el-input-number
          v-model="formData.line"
          theme="normal"
          :max="5000"
          :min="200"
          :controls="false"
          step-strictly
        ></el-input-number>
      </el-form-item>

      <el-form-item>
        <!-- <el-button type="primary" style="margin-left: 8px;" @click="getLog">查询</el-button> -->
        <el-button type="primary" @click="downLog">下载该天日志</el-button>
      </el-form-item>
    </el-form>

    <pre class="logs">
      {{ logs }}
    </pre>
  </div>
</template>

<style scoped>
.logs {
  margin-top: 20px;
  white-space: pre-wrap;
}
</style>

<script>
import { ref } from "vue";
import axios from "axios";
import { format } from "date-fns";

export default {
  setup() {
    let logs = ref(""),
      formData = ref({
        type: "info",
        date: new Date(),
        line: 200,
      })

    function createLogFile(content, fileName) {
      // 创建一个 Blob 对象，内容类型为纯文本
      //const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      const blob = new Blob([content], { type: "application/zip" });

      // 生成一个指向 Blob 对象的 URL
      const url = URL.createObjectURL(blob);

      // 创建一个 a 标签，用于触发下载
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // 设置下载文件名，包括 .log 后缀

      // 将 a 标签添加到 DOM 中，触发点击事件，然后移除
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 释放 Blob URL
      URL.revokeObjectURL(url);
    }

    async function getLog() {
      let { type, date, line } = formData.value;
      date = format(date, "yyyy-MM-dd");
      const { data } = await axios("log/log_content/", {
        params: { type, date, line },
        headers: { "Access-Token": localStorage.getItem("token") },
      });
      logs.value = data;
    }

    async function downLog() {
      let { type, date, line } = formData.value;
      date = format(date, "yyyy-MM-dd");
      const { data } = await axios("log/log_download/", {
        params: { type, date },
        responseType: "blob",
        headers: { "Access-Token": localStorage.getItem("token") },
      });

      createLogFile(data, `${date} ${type}.zip`);
    }

    return {logs, formData, createLogFile, getLog, downLog}
  }
}
</script>